var _path, _g, _path2, _path3, _path4, _path5, _g2, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardEmptyState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 252,
    height: 208,
    viewBox: "0 0 252 208",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127.818 173.333C174.053 173.333 211.534 136.024 211.534 90.0001C211.534 43.9763 174.053 6.66675 127.818 6.66675C81.5828 6.66675 44.1019 43.9763 44.1019 90.0001C44.1019 136.024 81.5828 173.333 127.818 173.333Z",
    fill: "#F8F4F9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1480_38503)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.067 163.849H35.9569C32.6159 163.849 29.8644 161.111 29.8644 157.785V85.0095C29.8644 81.6838 32.6159 78.9448 35.9569 78.9448H160.067C163.407 78.9448 166.159 81.6838 166.159 85.0095V157.785C166.159 161.111 163.407 163.849 160.067 163.849Z",
    fill: "url(#paint0_linear_1480_38503)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9408 115.537L63.8353 105.917C74.6303 106.66 83.1369 115.568 83.3743 126.204C83.4836 133.022 79.8966 139.048 74.42 142.472L69.4477 133.737C71.8755 131.992 73.3434 129.145 73.3923 125.747C73.3545 120.738 69.1012 116.284 63.9408 115.537Z",
    fill: "#90388B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7139 106.161L61.8184 115.703C58.701 115.968 55.8889 117.655 54.2464 120.26L45.985 114.816C49.2551 109.802 54.8793 106.428 61.7139 106.161Z",
    fill: "#E8D6EB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2224 117.344L52.677 122.8C52.398 123.761 52.1191 124.723 52.2345 125.924C52.2271 131.473 57.0292 136.145 62.9917 136.381C64.6431 136.359 66.1049 136.117 67.377 135.657L72.3056 144.109C69.527 145.4 66.384 146.057 63.096 145.907C51.7698 145.696 42.56 136.592 42.3553 125.669C42.3738 122.697 43.0061 119.791 44.2224 117.344Z",
    fill: "#CAA5D0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M95.113 92.835H41.8528C40.3788 92.835 39.1995 91.6612 39.1995 90.194C39.1995 88.7267 40.3788 87.553 41.8528 87.553H95.2112C96.6851 87.553 97.8643 88.7267 97.8643 90.194C97.8643 91.6612 96.5869 92.835 95.113 92.835Z",
    fill: "#CAA5D0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1480_38503)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.489 100.367H91.3791C88.0379 100.367 85.2866 97.6279 85.2866 94.302V21.5267C85.2866 18.201 88.0379 15.4622 91.3791 15.4622H215.489C218.83 15.4622 221.582 18.201 221.582 21.5267V94.302C221.582 97.6279 218.83 100.367 215.489 100.367Z",
    fill: "url(#paint1_linear_1480_38503)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M150.534 29.3518H97.2743C95.8002 29.3518 94.621 28.1781 94.621 26.7108C94.621 25.2436 95.8002 24.0698 97.2743 24.0698H150.633C152.106 24.0698 153.286 25.2436 153.286 26.7108C153.286 28.1781 152.008 29.3518 150.534 29.3518Z",
    fill: "#CAA5D0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M119.189 90.5854H113.882C113.096 90.5854 112.408 89.9006 112.408 89.1181C112.408 88.3354 113.096 87.6506 113.882 87.6506H119.189C119.975 87.6506 120.663 88.3354 120.663 89.1181C120.761 89.9006 120.073 90.5854 119.189 90.5854Z",
    fill: "#CAA5D0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M149.16 90.5854H143.853C143.066 90.5854 142.379 89.9006 142.379 89.1181C142.379 88.3354 143.066 87.6506 143.853 87.6506H149.16C149.945 87.6506 150.633 88.3354 150.633 89.1181C150.633 89.9006 149.945 90.5854 149.16 90.5854Z",
    fill: "#CAA5D0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M137.895 132.675H116.928C116.24 132.675 115.65 132.088 115.65 131.403V131.208C115.65 130.523 116.24 129.936 116.928 129.936H137.895C138.583 129.936 139.172 130.523 139.172 131.208V131.403C139.172 132.088 138.583 132.675 137.895 132.675Z",
    fill: "#CAA5D0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M128.196 120.607H116.928C116.24 120.607 115.65 120.02 115.65 119.336V119.14C115.65 118.455 116.24 117.868 116.928 117.868H128.196C128.884 117.868 129.474 118.455 129.474 119.14V119.336C129.474 120.02 128.884 120.607 128.196 120.607Z",
    fill: "#CAA5D0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M133.702 144.413H116.928C116.24 144.413 115.65 143.827 115.65 143.141V142.945C115.65 142.261 116.24 141.675 116.928 141.675H133.702C134.39 141.675 134.98 142.261 134.98 142.945V143.141C135.077 143.827 134.488 144.413 133.702 144.413Z",
    fill: "#CAA5D0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M179.132 90.5854H173.825C173.038 90.5854 172.351 89.9006 172.351 89.1181C172.351 88.3354 173.038 87.6506 173.825 87.6506H179.132C179.917 87.6506 180.606 88.3354 180.606 89.1181C180.704 89.9006 180.016 90.5854 179.132 90.5854Z",
    fill: "#CAA5D0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M209.397 90.5854H204.091C203.304 90.5854 202.616 89.9006 202.616 89.1181C202.616 88.3354 203.304 87.6506 204.091 87.6506H209.397C210.184 87.6506 210.872 88.3354 210.872 89.1181C210.872 89.9006 210.282 90.5854 209.397 90.5854Z",
    fill: "#CAA5D0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M100.912 78.2604H96.5874C95.8011 78.2604 95.1132 77.5757 95.1132 76.793C95.1132 76.0103 95.8011 75.3257 96.5874 75.3257H100.912C101.698 75.3257 102.386 76.0103 102.386 76.793C102.386 77.6734 101.698 78.2604 100.912 78.2604Z",
    fill: "#CAA5D0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M100.912 60.7512H96.5874C95.8011 60.7512 95.1132 60.0664 95.1132 59.2837C95.1132 58.5012 95.8011 57.8164 96.5874 57.8164H100.912C101.698 57.8164 102.386 58.5012 102.386 59.2837C102.386 60.0664 101.698 60.7512 100.912 60.7512Z",
    fill: "#CAA5D0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M100.912 43.2422H96.5874C95.8011 43.2422 95.1132 42.5574 95.1132 41.7747C95.1132 40.9922 95.8011 40.3074 96.5874 40.3074H100.912C101.698 40.3074 102.386 40.9922 102.386 41.7747C102.386 42.5574 101.698 43.2422 100.912 43.2422Z",
    fill: "#CAA5D0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M212.345 75.6191H109.46V76.5973H212.345V75.6191Z",
    fill: "#CAA5D0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M111.426 58.0125H109.46V58.9907H111.426V58.0125Z",
    fill: "#CAA5D0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M206.349 58.9906H202.419V58.0125H206.349V58.9906ZM198.488 58.9906H194.557V58.0125H198.488V58.9906ZM190.528 58.9906H186.598V58.0125H190.528V58.9906ZM182.668 58.9906H178.736V58.0125H182.668V58.9906ZM174.708 58.9906H170.777V58.0125H174.708V58.9906ZM166.847 58.9906H162.915V58.0125H166.847V58.9906ZM158.887 58.9906H154.956V58.0125H158.887V58.9906ZM151.026 58.9906H147.096V58.0125H151.026V58.9906ZM143.066 58.9906H139.135V58.0125H143.066V58.9906ZM135.205 58.9906H131.274V58.0125H135.205V58.9906ZM127.245 58.9906H123.315V58.0125H127.245V58.9906ZM119.286 58.9906H115.355V58.0125H119.286V58.9906Z",
    fill: "#CAA5D0"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M212.345 58.0125H210.378V58.9907H212.345V58.0125Z",
    fill: "#CAA5D0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M111.426 40.4053H109.46V41.3835H111.426V40.4053Z",
    fill: "#CAA5D0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M206.349 41.3834H202.419V40.4053H206.349V41.3834ZM198.488 41.3834H194.557V40.4053H198.488V41.3834ZM190.528 41.3834H186.598V40.4053H190.528V41.3834ZM182.668 41.3834H178.736V40.4053H182.668V41.3834ZM174.708 41.3834H170.777V40.4053H174.708V41.3834ZM166.847 41.3834H162.915V40.4053H166.847V41.3834ZM158.887 41.3834H154.956V40.4053H158.887V41.3834ZM151.026 41.3834H147.096V40.4053H151.026V41.3834ZM143.066 41.3834H139.135V40.4053H143.066V41.3834ZM135.205 41.3834H131.274V40.4053H135.205V41.3834ZM127.245 41.3834H123.315V40.4053H127.245V41.3834ZM119.286 41.3834H115.355V40.4053H119.286V41.3834Z",
    fill: "#CAA5D0"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M212.345 40.4053H210.378V41.3835H212.345V40.4053Z",
    fill: "#CAA5D0"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M107.79 134.241H105.136C104.153 134.241 103.465 133.459 103.465 132.578V129.936C103.465 128.958 104.252 128.273 105.136 128.273H107.79C108.772 128.273 109.46 129.056 109.46 129.936V132.578C109.46 133.556 108.674 134.241 107.79 134.241Z",
    fill: "#CAA5D0"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M107.79 122.173H105.136C104.153 122.173 103.465 121.39 103.465 120.51V117.868C103.465 116.89 104.252 116.206 105.136 116.206H107.79C108.772 116.206 109.46 116.988 109.46 117.868V120.51C109.46 121.488 108.674 122.173 107.79 122.173Z",
    fill: "#E8D6EB"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M107.79 145.979H105.136C104.153 145.979 103.465 145.196 103.465 144.316V141.675C103.465 140.696 104.252 140.011 105.136 140.011H107.79C108.772 140.011 109.46 140.793 109.46 141.675V144.316C109.46 145.293 108.674 145.979 107.79 145.979Z",
    fill: "#90388B"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M119.581 56.9365H113.685C112.211 56.9365 111.032 58.1103 111.032 59.5775V75.6195H122.235V59.5775C122.235 58.1103 121.055 56.9365 119.581 56.9365Z",
    fill: "#90388B"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M149.453 48.8176H143.557C142.084 48.8176 140.904 49.9914 140.904 51.4586V75.5215H152.205V51.4586C152.106 49.9914 150.928 48.8176 149.453 48.8176Z",
    fill: "#90388B"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M179.524 67.8916H173.628C172.153 67.8916 170.974 69.0656 170.974 70.5329V75.522H182.177V70.5329C182.177 69.0656 180.999 67.8916 179.524 67.8916Z",
    fill: "#90388B"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M209.691 43.1443H203.794C202.321 43.1443 201.142 44.318 201.142 45.7852V75.6192H212.443V45.7852C212.344 44.318 211.165 43.1443 209.691 43.1443Z",
    fill: "#90388B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1480_38503",
    x: 19.8644,
    y: 72.9448,
    width: 156.295,
    height: 104.904,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.909804 0 0 0 0 0.839216 0 0 0 0 0.921569 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1480_38503"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1480_38503",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1480_38503",
    x: 75.2866,
    y: 9.46216,
    width: 156.295,
    height: 104.905,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.909804 0 0 0 0 0.839216 0 0 0 0 0.921569 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1480_38503"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1480_38503",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1480_38503",
    x1: 97.9679,
    y1: 76.9809,
    x2: 97.9679,
    y2: 164.764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F8F4F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1480_38503",
    x1: 153.39,
    y1: 13.4983,
    x2: 153.39,
    y2: 101.281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F8F4F9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardEmptyState);
export default __webpack_public_path__ + "static/media/dashboard-empty-state.85c4b953125190b077f90708b14ea46a.svg";
export { ForwardRef as ReactComponent };